/**
 * Generated by kubb.
 * Do not edit manually.
 * Shape Global API
 */

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../global-client';
import type { RequestConfig, ResponseErrorConfig } from '../../global-client';
import type { GetApiUsersMeQueryResponseSchema, GetApiUsersMe401Schema } from '../types/getApiUsersMeSchema';

function getGetApiUsersMeUrl() {
  const res = { method: 'GET', url: `/api/users/me` as const };
  return res;
}

/**
 * @summary Retrieves current user
 * {@link /api/users/me}
 */
export async function getApiUsersMe(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetApiUsersMeQueryResponseSchema, ResponseErrorConfig<GetApiUsersMe401Schema>, unknown>({
    method: 'GET',
    url: getGetApiUsersMeUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
